function loadScript() {
  if (window.zxcvbn) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';
    script.integrity = 'sha256-Znf8FdJF85f1LV0JmPOob5qudSrns8pLPZ6qkd/+F0o=';
    script.crossOrigin = 'anonymous';
    script.onload = resolve;
    script.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}
function checkPasswordStrength(password) {
  return loadScript().then(() => {
    if (password) {
      return window.zxcvbn(password);
    }
    return 0;
  });
}

export { checkPasswordStrength };
//# sourceMappingURL=password-strength.js.map
